// extracted by mini-css-extract-plugin
module.exports = {"title":"love-story-grid_title__ZIOyr","stories":"love-story-grid_stories__XNxHr"};